module.exports = __webpack_public_path__ + "61871c224b8ef8899d2682d1170d9301.MP3";